module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "praise1"
  }, [_c('a', {
    attrs: {
      "id": "page_ii"
    }
  }, [_vm._v("“ANYONE WHO LOVES ROMANCE MUST READ SABRINA JEFFRIES! ”")])]), _c('a', {
    attrs: {
      "id": "page_ii"
    }
  }, [_c('p', {
    staticClass: "att1"
  }, [_vm._v("—"), _c('span', {
    staticClass: "txit"
  }, [_vm._v("New York Times")]), _vm._v(" bestselling author Lisa Kleypas")]), _vm._v(" "), _c('p', {
    staticClass: "praisec"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("The Sinful Suitors")])]), _vm._v(" "), _c('p', {
    staticClass: "praises"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Sabrina Jeffries’s delightful Regency series featuring the St. George’s Club, where watchful guardians conspire to keep their unattached sisters and wards out of the clutches of sinful suitors.")])]), _vm._v(" "), _c('p', {
    staticClass: "praised"
  }, [_c('span', {
    staticClass: "txbfit"
  }, [_vm._v("THE ART OF SINNING")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“With every book, Jeffries grows into an even more accomplished writer whose memorable characters and unforgettable stories speak to readers on many levels.”")]), _vm._v(" "), _c('p', {
    staticClass: "att"
  }, [_vm._v("—"), _c('span', {
    staticClass: "txit"
  }, [_vm._v("RT Book Reviews")]), _vm._v(" (4"), _c('sup', {
    staticClass: "sup"
  }, [_vm._v("1")]), _vm._v("/"), _c('sub', {
    staticClass: "sub"
  }, [_vm._v("2")]), _vm._v(" stars, Top Pick)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Veteran historical romance author Jeffries launches her Sinful Suitors Regency series with two effortlessly crafted charismatic protagonists.”")]), _vm._v(" "), _c('p', {
    staticClass: "att"
  }, [_vm._v("—"), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Publishers Weekly")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“"), _c('span', {
    staticClass: "txit"
  }, [_vm._v("The Art of Sinning")]), _vm._v(" is an endearing beginning to a new series, and showcases Jeffries’s talents in making the reader swoon in delight.”")]), _vm._v(" "), _c('p', {
    staticClass: "att"
  }, [_vm._v("—"), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Fresh Fiction")])]), _vm._v(" "), _c('p', {
    staticClass: "praisec1"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Also from")]), _vm._v(" "), _c('span', {
    staticClass: "txbfit"
  }, [_vm._v("New York Times")]), _vm._v(" "), _c('span', {
    staticClass: "txbf"
  }, [_vm._v("and")]), _vm._v(" "), _c('span', {
    staticClass: "txbfit"
  }, [_vm._v("USA Today")]), _vm._v(" "), _c('span', {
    staticClass: "txbf"
  }, [_vm._v("bestselling author SABRINA JEFFRIES")])]), _vm._v(" "), _c('p', {
    staticClass: "praisec"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("The Duke’s Men")])]), _vm._v(" "), _c('p', {
    staticClass: "praises"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("They are an investigative agency born out of family pride and irresistible passion . . . and they risk their lives and hearts to unravel any shocking deception or scandalous transgression!")])]), _vm._v(" "), _c('p', {
    staticClass: "praised"
  }, [_c('span', {
    staticClass: "txbfit"
  }, [_vm._v("IF THE VISCOUNT FALLS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Jeffries’s addictive series satisfies.“")]), _vm._v(" "), _c('p', {
    staticClass: "att"
  }, [_vm._v("—"), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Library Journal")])])]), _c('p', {
    staticClass: "praised"
  }, [_c('a', {
    attrs: {
      "id": "page_ii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_iii"
    }
  }, [_c('span', {
    staticClass: "txbfit"
  }, [_vm._v("HOW THE SCOUNDREL SEDUCES")])])]), _c('a', {
    attrs: {
      "id": "page_iii"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Scorching . . . From cover to cover, it sizzles.”")]), _vm._v(" "), _c('p', {
    staticClass: "att"
  }, [_vm._v("—"), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Reader to Reader")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Marvelous storytelling . . . Memorable.”")]), _vm._v(" "), _c('p', {
    staticClass: "att"
  }, [_vm._v("—"), _c('span', {
    staticClass: "txit"
  }, [_vm._v("RT Book Reviews")]), _vm._v(" (4"), _c('sup', {
    staticClass: "sup"
  }, [_vm._v("1")]), _vm._v("/"), _c('sub', {
    staticClass: "sub"
  }, [_vm._v("2")]), _vm._v(" stars, Top Pick, K.I.S.S. Award)")]), _vm._v(" "), _c('p', {
    staticClass: "praised"
  }, [_c('span', {
    staticClass: "txbfit"
  }, [_vm._v("WHEN THE ROGUE RETURNS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Blends the pace of a thriller with the romance of the Regency era.”")]), _vm._v(" "), _c('p', {
    staticClass: "att"
  }, [_vm._v("—"), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Woman’s Day")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Enthralling . . . rich in passion and danger.”")]), _vm._v(" "), _c('p', {
    staticClass: "att"
  }, [_vm._v("—"), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Booklist")]), _vm._v(" (starred review)")]), _vm._v(" "), _c('p', {
    staticClass: "praised"
  }, [_c('span', {
    staticClass: "txbfit"
  }, [_vm._v("WHAT THE DUKE DESIRES")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“A totally engaging, adventurous love story with an oh-so-wonderful ending.”")]), _vm._v(" "), _c('p', {
    staticClass: "att"
  }, [_vm._v("—"), _c('span', {
    staticClass: "txit"
  }, [_vm._v("RT Book Reviews")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Full of all the intriguing characters, brisk plotting, and witty dialogue that Jeffries’s readers have come to expect.”")]), _vm._v(" "), _c('p', {
    staticClass: "att"
  }, [_vm._v("—"), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Publishers Weekly")]), _vm._v(" (starred review)")]), _vm._v(" "), _c('p', {
    staticClass: "praisec1"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("The")]), _vm._v(" "), _c('span', {
    staticClass: "txbfit"
  }, [_vm._v("New York Times")]), _vm._v(" "), _c('span', {
    staticClass: "txbf"
  }, [_vm._v("bestselling")]), _vm._v(" "), _c('span', {
    staticClass: "txbf"
  }, [_vm._v("“must-read series” (")]), _c('span', {
    staticClass: "txbfit"
  }, [_vm._v("Romance Reviews Today")]), _c('span', {
    staticClass: "txbf"
  }, [_vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "praisec2"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("The Hellions of Halstead Hall")])]), _vm._v(" "), _c('p', {
    staticClass: "praised"
  }, [_c('span', {
    staticClass: "txbfit"
  }, [_vm._v("A LADY NEVER SURRENDERS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Jeffries pulls out all the stops . . . Not to be missed.”")]), _vm._v(" "), _c('p', {
    staticClass: "att"
  }, [_vm._v("—"), _c('span', {
    staticClass: "txit"
  }, [_vm._v("RT Book Reviews")]), _vm._v(" (4"), _c('sup', {
    staticClass: "sup"
  }, [_vm._v("1")]), _vm._v("/"), _c('sub', {
    staticClass: "sub"
  }, [_vm._v("2")]), _vm._v(" stars, Top Pick)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Sizzling, emotionally satisfying . . . Another must-read.”")]), _vm._v(" "), _c('p', {
    staticClass: "att"
  }, [_vm._v("—"), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Library Journal")]), _vm._v(" (starred review)")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_iii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_iv"
    }
  }, [_vm._v("“"), _c('span', {
    staticClass: "txit"
  }, [_vm._v("A Lady Never Surrenders")]), _vm._v(" wraps up the series nothing short of brilliantly.”")])]), _c('a', {
    attrs: {
      "id": "page_iv"
    }
  }, [_c('p', {
    staticClass: "att"
  }, [_vm._v("—"), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Booklist")])]), _vm._v(" "), _c('p', {
    staticClass: "praised"
  }, [_c('span', {
    staticClass: "txbfit"
  }, [_vm._v("TO WED A WILD LORD")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Wonderfully witty, deliciously seductive, graced with humor and charm.”")]), _vm._v(" "), _c('p', {
    staticClass: "att"
  }, [_vm._v("—"), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Library Journal")]), _vm._v(" (starred review)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“A beguiling blend of captivating characters, clever plotting, and sizzling sensuality.”")]), _vm._v(" "), _c('p', {
    staticClass: "att"
  }, [_vm._v("—"), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Booklist")])]), _vm._v(" "), _c('p', {
    staticClass: "praised"
  }, [_c('span', {
    staticClass: "txbfit"
  }, [_vm._v("HOW TO WOO A RELUCTANT LADY")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Delightful . . . Charmingly original.”")]), _vm._v(" "), _c('p', {
    staticClass: "att"
  }, [_vm._v("—"), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Publishers Weekly")]), _vm._v(" (starred review)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Steamy passion, dangerous intrigue, and just the right amount of tart wit.”")]), _vm._v(" "), _c('p', {
    staticClass: "att"
  }, [_vm._v("—"), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Booklist")])]), _vm._v(" "), _c('p', {
    staticClass: "praised"
  }, [_c('span', {
    staticClass: "txbfit"
  }, [_vm._v("A HELLION IN HER BED")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Jeffries’s sense of humor and delightfully delicious sensuality spice things up! ”")]), _vm._v(" "), _c('p', {
    staticClass: "att"
  }, [_vm._v("—"), _c('span', {
    staticClass: "txit"
  }, [_vm._v("RT Book Reviews")]), _vm._v(" (4"), _c('sup', {
    staticClass: "sup"
  }, [_vm._v("1")]), _vm._v("/"), _c('sub', {
    staticClass: "sub"
  }, [_vm._v("2")]), _vm._v(" stars)")]), _vm._v(" "), _c('p', {
    staticClass: "praised"
  }, [_c('span', {
    staticClass: "txbfit"
  }, [_vm._v("THE TRUTH ABOUT LORD STONEVILLE")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Jeffries combines her hallmark humor, poignancy, and sensuality to perfection.”")]), _vm._v(" "), _c('p', {
    staticClass: "att"
  }, [_vm._v("—"), _c('span', {
    staticClass: "txit"
  }, [_vm._v("RT Book Reviews")]), _vm._v(" (4"), _c('sup', {
    staticClass: "sup"
  }, [_vm._v("1")]), _vm._v("/"), _c('sub', {
    staticClass: "sub"
  }, [_vm._v("2")]), _vm._v(" stars, Top Pick)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Delectably witty dialogue . . . and scorching sexual chemistry.”")]), _vm._v(" "), _c('p', {
    staticClass: "attb"
  }, [_vm._v("—"), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Booklist")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d595724","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/praise.vue
// module id = 60
// module chunks = 0